import {useState} from "react";
import {withTranslation} from "react-i18next";
import {
    LogoutOutlined
} from '@ant-design/icons';

import "../cervo.scss";
import {Button} from 'antd';
import {history} from '_helpers/history'
import StepCervoTwo from "./stepCervoTwo";
import StepCervoThree from "./stepCervoThree";
import StepCervoFour from "./stepCervoFour";
import StepCervoFive from "./stepCervoFive";
import StepCervoVideo from "./StepCervoVideo";
import {xcService} from "../../../../../_services/xcService";


function StepCervoOne(props) {

    const {t, i18n} =props;
    const [step, setStep] = useState(1);
    const goTo = (number) => {

        setStep(number)
    }


    const saveGamed = () => {
        xcService.putToken("/v1/savegame", {quest: 'quest2'}).then( (data ) => {
            setStep(2);
        }).catch( (err) =>  setStep(2))


    }
    return (
<>
    {step === 1 &&

        <div className={"backGroundCervo first"}>
            <div className={"wrapper boxed"}>
                <div className={"insideCervo boxed"}>
                    <Button
                      onClick={() => history.push("/admin/assessment")}
                      className="primaryButton btn-icon-text" icon={<LogoutOutlined/>}>{t("exit")}</Button>
                </div>
                <div className={"initCervo"}>
                    <h2>{t("cervo.title")}</h2>
                    <h3>{t("cervo.antes")} <strong>{t("cervo.quequieres")}</strong></h3>
                    <div className={"content-cards"}>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/puertas-dokia.png"} onClick={() => history.push("/admin/assessment")}/>
                                <Button type={"primary"}
                                        onClick={() => saveGamed()}
                                        className="primaryButton">{t("cervo.conocer")}</Button>
                            </div>
                        </div>
                        <div className={"card"}>
                            <div className={"chooseOp"}>
                                <img src={"/assets/img/goquestion2.png"} onClick={() => history.push("/admin/start-cervo")}/>
                                <Button
                                        onClick={() => history.push("/admin/cervo-instructions")}
                                        className="primaryButton">{t("cervo.ird")}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    {step === 2 &&
        <StepCervoTwo goTo={goTo} />
    }
    {step === 3 &&
        <StepCervoVideo goTo={goTo} />
    }
    {step === 4 &&
        <StepCervoThree goTo={goTo} />
    }
    {step === 5 &&
        <StepCervoFour goTo={goTo} />
    }
    {step === 6 &&
        <StepCervoFive goTo={goTo} />
    }
</>

    )
}

export default withTranslation()(StepCervoOne);
